import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Login from './Components/Login';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter, Routes,Route} from 'react-router-dom'
import Cart from './Components/Cart'
import Info from './Components/Info'
import CartItem from './Components/CartItem';
import User from './Components/User';
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Login/>}/>
        <Route path='/home' element={<App/>}>
            <Route path='info:id' element={<Info/>}/>
            <Route path='cart' element={<Cart/>}/>
            <Route path='cartitem' element={<CartItem/>}/>
            <Route path='user' element={<User/>}/>
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
